export const stockApi = {
    stock: {
        restful: {
            list: '/stocks',
        },
        getLineData: '/stock/line_data',
        getLines: '/stock/lines',
        updateIsStar: '/stock/update_is_star',
        getIndustryStats: '/stock/industry_stats',
        getSentiments: '/stock/sentiments',
        sync: '/stock/sync',
        syncLines: '/stock/sync_lines',
    },
    industry: {
        list: '/industries',
        create: '/industry',
        getStocks: '/industry/stocks',
        init: '/industry/init',
        analyze: '/industry/analyze',
        relationStock: '/industry/relation_stocks',
        makeSentiments: '/industry/make_sentiments',
        getSentiments: '/industry/sentiments',
    },
    // 财务数据
    financial: {
        restful: {
            list: '/financials',
        }
    },
}